// const http_host = 'https://paradise.api.airland100.com';
const http_host = 'https://paradise.api.airland100.com';
// const http_host = 'api';
export default {
    http_host,
}